/**
 * One type scale for every screen — the `--fs-title/section/body/small/
 * figure` tokens in `tokens.css`, which `base.css` uses too, so a size is
 * changed in one place. One font: IBM Plex Sans.
 */
const fontSans =
	"'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

export const typography = {
	fontFamily: fontSans,
	h1: { fontSize: 'var(--fs-title)', lineHeight: 1.3, fontWeight: 600 },
	h2: { fontSize: 'var(--fs-section)', lineHeight: 1.4, fontWeight: 600 },
	h3: { fontSize: 'var(--fs-section)', lineHeight: 1.4, fontWeight: 600 },
	h4: { fontSize: 'var(--fs-section)', lineHeight: 1.4, fontWeight: 600 },
	h5: { fontSize: 'var(--fs-section)', lineHeight: 1.4, fontWeight: 600 },
	h6: { fontSize: 'var(--fs-section)', lineHeight: 1.4, fontWeight: 600 },
	subtitle1: { fontSize: 'var(--fs-body)', lineHeight: 1.5 },
	subtitle2: {
		fontSize: 'var(--fs-small)',
		lineHeight: 1.5,
		fontWeight: 500,
	},
	body1: { fontSize: 'var(--fs-body)', lineHeight: 1.5 },
	body2: { fontSize: 'var(--fs-body)', lineHeight: 1.5 },
	caption: { fontSize: 'var(--fs-small)', lineHeight: 1.4 },
	overline: {
		fontSize: 'var(--fs-small)',
		lineHeight: 1.4,
		textTransform: 'none' as const,
		letterSpacing: 0,
	},
	button: {
		fontSize: 'var(--fs-body)',
		textTransform: 'none' as const,
		letterSpacing: 0,
		fontWeight: 500,
	},
	/* Technical values (ids, hashes, storage keys). Same font as everything
     else — one font across the app — just the small size. */
	mono: {
		fontFamily: fontSans,
		fontSize: 'var(--fs-small)',
		lineHeight: 1.4,
	},
};
